const initialState = () => ({
    form: null,
    preview: false,
    score: null,
    review: null,
    reviewSuggestion: null,
    showRating: false,
    showForm: false,
    showOptions: false,
    success: false,
    copied: false,
    selectingLocation: false,
});

const state = initialState();

const getters = {

    form: state => {
        return state.form;
    },

    preview: state => {
        return state.preview;
    },

    score: state => {
        return state.score;
    },

    review: state => {
        return state.review;
    },

    reviewSuggestion: state => {
        return state.reviewSuggestion;
    },

    showRating: state => {
        return state.showRating;
    },

    showForm: state => {
        return state.showForm;
    },

    showOptions: state => {
        return state.showOptions;
    },

    success: state => {
        return state.success;
    },

    copied: state => {
        return state.copied;
    },

    selectingLocation: state => {
        return state.selectingLocation;
    },

}

const mutations = {

    setForm(state, form) {
        state.form = form;
    },

    setPreview(state, preview) {
        state.preview = preview;
    },

    setScore(state, score) {
        state.score = score;
    },

    setReview(state, review) {
        state.review = review;
    },

    setReviewSuggestion(state, reviewSuggestion) {
        state.reviewSuggestion = reviewSuggestion;
    },

    setShowRating(state, showRating) {
        state.showRating = showRating;
    },

    setShowForm(state, showForm) {
        state.showForm = showForm;
    },

    setShowOptions(state, showOptions) {
        state.showOptions = showOptions;
    },

    setSuccess(state, success) {
        state.success = success;
    },

    setCopied(state, copied) {
        state.copied = copied;
    },

    setSelectingLocation(state, selectingLocation) {
        state.selectingLocation = selectingLocation;
    },

    resetFlow(state) {
        const form = state.form;
        const preview = state.preview;
        Object.assign(state, initialState());
        state.form = form;
        state.preview = preview;
    },

    reset(state) {
        Object.assign(state, initialState());
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
